import DashboardStats from "@/pages/dashboard/components/overview/dashboard-stats/dashboard-stats.vue";
import DashboardQrCode from "@/pages/dashboard/components/overview/dashboard-qr-code/dashboard-qr-code.vue";
import DashboardNotifications from "@/pages/dashboard/components/overview/dashboard-notifications/dashboard-notifications.vue";
import DashboardAnnouncements from "@/pages/dashboard/components/overview/dashboard-announcements/dashboard-announcements.vue";

export default {
    name: "ProfileOverview",
    components: {
        DashboardAnnouncements,
        DashboardNotifications,
        DashboardQrCode,
        DashboardStats,
    },
};


// WEBPACK FOOTER //
// ./src/pages/dashboard/partials/dashboard-overview/dashboard-overview.js